import { ACTION_TYPE } from "../actions/ActionTypes";

const INITIAL_STATE = {
	page: 0,
	rowsPerPage: 10
}

const logsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
		case ACTION_TYPE.LOGS.CHANGE_PAGE: 
			return { ...state, page: action.payload }
			
		case ACTION_TYPE.LOGS.CHANGE_ROWS_PER_PAGE:
			return { ...state, rowsPerPage: action.payload }

		default: 
      return state
	}	
}

export default logsReducer;


// WEBPACK FOOTER //
// ./src/reducers/logsReducer.js